import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { Grid } from "@material-ui/core";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
import { AutocompleteForm } from "components";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
}));
const campoRequerido = {
  required: { value: true, message: "Campo requerido" },
};
export default function FormularioGrupo(props) {
  const {
    control,
    register,
    errors,
    catalogo,
    defaultItem,
  } = props;
  const classes = useStyles();
  const classesTablero = useStylesTablero();

  return (
    <Grid container className={classes.root} spacing={2}>
      <Grid item xs={12}>
      <AutocompleteForm
          control={control}
          name="proyecto"
          label="SISTEMA"
          variant="outlined"
          rules={campoRequerido}
          error={Boolean(errors?.proyecto)}
          defaultValue={defaultItem.idproyecto?{idproyecto:defaultItem.idproyecto, nproyecto:defaultItem.nproyecto}:null}
          options={catalogo}
          optionSelected={{
            label: "nproyecto",
            id: "idproyecto",
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="MODULO"
          name="nmodulo"
          variant="outlined"
          defaultValue={defaultItem.nmodulo}
          inputRef={register(campoRequerido)}
          error={Boolean(errors?.nmodulo)}
          helperText={errors.nmodulo}
          className={classesTablero.field}
        />
      </Grid>
    </Grid>
  );
}
